<template>
  <div class="overlay" :class="{ 'is-active': isActive }" />
</template>

<script>
export default {
  computed: {
    isActive() {
      return this.$store.getters['common/getOverlay'];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/settings/config.scss";

.overlay {
  position: absolute;
  height: 10000vh;
  width: 100%;
  display: none;
  top: 0;
  &.is-active {
    display: block;
    @include overlay(0.4, $darkBlack);
    z-index: 900;
    &:after {
      z-index: 900;
    }
  }
}
</style>
